import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import FreeUpgradeCta from './FreeUpgradeCta';

export default withRouter(withUser(FreeUpgradeCta));
